import React, { useState, useEffect } from "react";
import Style from "./AddNewProduct.module.css";
import "../SupermarketProduct/SupermarketProduct.css";
import { useForm } from "react-hook-form";
import Resizer from "react-image-file-resizer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faImages,
  faPlus,
  faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
import { AddProductSuppermarketAPI, getBrandListApi } from "../../../Api/SupplierServices";
import { errorToast, succToast } from "../../../Utils/Toast/Toast";

const AddNewProduct = () => {
  /////////////////////// State Part //////////////////////
  const [disable, setDisable] = useState(false);
  const [files, setFiles] = useState([]);
  const [isBigImg, setIsBigImg] = useState(false);
  const [imgName, setImgName] = useState();
  const [openModal, setOpenModal] = useState(false);
  const [brands, setBrands] = useState([]);
  const [chooseBrand, setChooseBrand] = useState();

  //////////////////// useForm define ////////////////////
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    getBrandList();
  }, []);
  /////////////////// form function To send Data //////////////////////
  const onSubmit = (data,e) => {
    setDisable(true)
    const info = {
      file: files,
      name: data.name,
      barcode_1: data.barcode1 === "" ? 0 : parseInt(data.barcode1),
      barcode_2: data.barcode2 === "" ? 0 : parseInt(data.barcode2),
      barcode_3: data.barcode3 === "" ? 0 : parseInt(data.barcode3),
      price: data.price === "" ? 0 : data.price,
      count: data.count === "" ? 0 : data.count,
      max_count: data.maxCount === "" ? 0 : data.maxCount,
      other_detail: data.maxCount === "" ? "" : data.describe,
      category_id: 27,
      off_price: data.off ? data.off : 0,
      new: "1",
      brand_id: parseInt(chooseBrand.value),
      weight: data.weight === "" ? 0 : parseInt(data.weight),
      volume: data.volume === "" ? 0 : parseInt(data.volume),
      category_free: 0,
    };
    console.log(info);
    AddProductSuppermarketAPI(info, (res) => {
        if (res.status === 0) {
          errorToast(res.message);
        //   setLoading(false);
          setDisable(false);
          e.target.reset();
        } else {
          e.target.reset();
          succToast(res.message);
        //   setLoading(false);
          setDisable(false);
        }
    });
  };
  ///////////////نمایش بزرگتر عکس
  const showBigPic = (img) => {
    setIsBigImg(true);
    setImgName(img);
  };
  ////////////حذف عکس
  const removeImage = (name) => {
    const newList = files.filter((item) => item !== name);
    setFiles(newList);
  };
  ////////////// Upload Image /////////////////
  const UploadImage = async (images) => {
    return await resizeFile(images);
  };

  const resizeFile = (file) => {
    for (let i = 0; i < file.length; i++) {
      Resizer.imageFileResizer(
        file[i],
        1024,
        1024,
        "WEBP",
        100,
        0,
        (uri) => {
          setFiles((prevfiles) => [...prevfiles, uri]);
        },
        "base64"
      );
    }
  };
//////////////// add brand modal /////////////
  const AddBrandHandler = () => {
    setOpenModal(true);
  };
//////////////// add brand modal /////////////
  const handleCloseModal = () => {
    setOpenModal(false);
  };
/////////////////// get brand list ///////////////
  const getBrandList = async () => {
    const result = await getBrandListApi();
    setBrands(result.brand);
  };
////////////////// ready for select ///////////////
  let brandOption =
  brands &&
  brands.map((item) => {
    return { value: item.id, label: item.brand_persian };
  });

  return (
    <div className={Style.componentHolder}>
      <h2 className={Style.titleOfComponent}>افزودن محصول جدید</h2>
      <hr
        style={{
          height: "3px",
          border: "none",
          color: "#c20c64",
          backgroundColor: "#c20c64",
        }}
      />
      {isBigImg ? (
        <div className={Style.bigImg} onClick={() => setIsBigImg(false)}>
          <img src={`${imgName}`} alt="" />
        </div>
      ) : null}
      <form onSubmit={handleSubmit(onSubmit)} className={Style.FormAddProduct}>
        <div className={Style.imagePart}>
          {files.map((item, index) => {
            return (
              <div key={index} className={Style.eachImage}>
                <div
                  className={Style.picHolder}
                  onClick={() => showBigPic(item)}
                >
                  <img src={`${item}`} alt="" />
                </div>
                <div
                  className={Style.iconHolder}
                  onClick={() => removeImage(item)}
                >
                  <FontAwesomeIcon icon={faTrashAlt} />
                </div>
              </div>
            );
          })}
        </div>
        <div className={Style.inptFileHolder}>
          <label className={Style.lablePart} htmlFor="imgSelect">
            <FontAwesomeIcon icon={faImages} />
          </label>
          <p className={Style.placeHolderInput}>بارگذاری تصویر</p>
          <input
            {...register("pic")}
            className={Style.fileInputPart}
            type="file"
            id={"imgSelect"}
            onChange={(e) => UploadImage(e.target.files)}
            multiple
          />
        </div>
        <input
          {...register("name",{required:true})}
          className={errors.name ? Style.errorInput :Style.fileInputPart2}
          placeholder={"نام محصول"}
        />
        <div className={Style.selectHolder}>
          <FontAwesomeIcon
            icon={faPlus}
            className={Style.plusIcon}
            onClick={AddBrandHandler}
          />
          <Select
            {...register("brand")}
            onChange={setChooseBrand}
            className={Style.selectOptionsearch}
            placeholder={"برند محصول"}
            options={brandOption}
          />
        </div>

        <input
          {...register("weight")}
          className={Style.fileInputPart2}
          placeholder={"وزن به گرم"}
        />
        <input
          {...register("volume")}
          className={Style.fileInputPart2}
          placeholder={"حجم به میلی لیتر"}
        />

        <input
          {...register("barcode1")}
          className={Style.fileInputPart2}
          placeholder={"بارکد شماره یک"}
        />
        <input
          {...register("barcode2")}
          className={Style.fileInputPart2}
          placeholder={"بارکد شماره دو"}
          type="text"
        />
        <input
          {...register("barcode3")}
          className={Style.fileInputPart2}
          placeholder={"بارکد شماره سه"}
          type="text"
        />
        <input
          {...register("maxCount", { required: true })}
          className={errors.maxCount ? Style.errorInput : Style.fileInputPart2}
          placeholder={"حداکثر تعداد"}
          type="text"
        />
        <input
          {...register("price", { required: true })}
          className={errors.price ? Style.errorInput : Style.fileInputPart2}
          placeholder={"قیمت به تومان"}
          type="text"
        />
        <input
          {...register("off")}
          className={errors.off ? Style.errorInput : Style.fileInputPart2}
          placeholder={"قیمت با تخفیف به تومان"}
          type="text"
        />
        <input
          {...register("count", { required: true })}
          className={errors.count ? Style.errorInput : Style.fileInputPart2}
          placeholder={"تعداد"}
          type="text"
        />
        <textarea
          {...register("describe")}
          placeholder={"توضیحات تکمیلی"}
          className={Style.fileInputArea}
        />
        <div style={{ display: "flex", justifyContent: "center" }}>
          <button className={Style.btnStyle} type={"submit"} disabled={disable}>
            ثبت
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddNewProduct;
